import { getWebchatHistory } from '@/services/webchat-service/webchat.service';
import { WebchatHistoryParams } from '@/services/webchat-service/webchat.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useWebchatHistory = (params: WebchatHistoryParams) => {
  const { data: historyData, isPending } = useQuery({
    queryKey: ReactQueryKeys.WEBCHAT_HISTORY(params),
    queryFn: () => getWebchatHistory(params),
  });

  return { historyData, isPending };
};
